<app-vw-pb-create-label>
  <ng-template appVwPbCreateLabelForm [formGroup]="form">
    <mat-form-field
      appearance="outline"
      class="tw-flex tw-w-full"
      *ngIf="data.batches.length > 0"
    >
      <mat-label>Seleccionar Batch</mat-label>
      <mat-select formControlName="workOrderBatch">
        <mat-option>
          <ngx-mat-select-search
            formControlName="search"
            placeholderLabel="Buscar..."
            noEntriesFoundLabel="Sin resultados"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let val of filteredBatches" [value]="val.id">
          {{ getStringBatch(val) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
</app-vw-pb-create-label>
